module.exports = __webpack_public_path__ + "ed33cf0e793f6a85c1d8998c96c70919.png";